import axios from 'axios';
import { decompressData } from '/src/utils/decompressData';

export const FetchCensusHousingIncomeInfo = async (zip, fips, census_tract) => {
    // console.log(property);
    try {
        const response = await axios.post(
            `${import.meta.env.VITE_API_BASE_URL}/get-census-housing`,
            {
                zip: zip,
                fips: fips,
                census_tract: census_tract
            }
        );

        if (response.data) {
            // Return decompressed data without touching localStorage
            return response.data;
        }
        return null;
    } catch (error) {
        console.error('Error fetching census housing income info:', error);
        if (error.response) {
            console.error('Error response:', error.response.data);
        }
        throw error;
    }
};
